import { useEffect, useMemo, useState } from "react";
import { useInfiniteQuery, UseInfiniteQueryOptions } from "react-query";

type QueryFnType<TData> = (context: { pageParam?: any }) => Promise<TData>;

type UsePreloadedInfiniteQueryOptions<TData, TError> = Omit<
  UseInfiniteQueryOptions<TData, TError, TData, TData, any>,
  "queryKey" | "queryFn"
>;

export function usePreloadedInfiniteQuery<TData, TError = unknown>(
  queryKey: any[],
  queryFn: QueryFnType<TData>,
  options?: UsePreloadedInfiniteQueryOptions<TData, TError>
) {
  // const [isPreloading, setIsPreloading] = useState(false);

  // const result = useInfiniteQuery<TData, TError>({
  //   queryKey,
  //   queryFn,
  //   ...options,
  // });

  // // Preload the next page after the first page is fetched but do not show it yet
  // useEffect(() => {
  //   if (
  //     !isPreloading &&
  //     result.data?.pages.length === 1 &&
  //     result.hasNextPage
  //   ) {
  //     setIsPreloading(true);
  //     result.fetchNextPage().finally(() => setIsPreloading(false));
  //   }
  // }, [result.data, result.hasNextPage, isPreloading, result.fetchNextPage]);

  // // Fetch the next page in advance after rendering a cached page
  // const fetchNextPageWithPreload = async () => {
  //   if (result.hasNextPage) {
  //     await result.fetchNextPage();
  //     if (result.hasNextPage) {
  //       result.fetchNextPage(); // Preload the next one in cache
  //     }
  //   }
  // };

  // return {
  //   ...result,
  //   fetchNextPage: fetchNextPageWithPreload,
  // };
  const [loadMore, setLoadMore] = useState<boolean>(true);
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery<TData, TError>(queryKey, queryFn, options);
  const pages = useMemo(() => data?.pages || [], [data]);
  // Preload the next page
  const preloadNextPage = async () => {
    if (hasNextPage) {
      await fetchNextPage();
      return;
    }
    setLoadMore(false);
  };

  // Fetch the first two pages initially
  useEffect(() => {
    if (pages.length === 1) {
      preloadNextPage();
    }
  }, [data, hasNextPage]);

  // Custom fetchNextPage to preload the next page

  const retPages = [...pages];
  if (loadMore && retPages.length > 1 && !isFetchingNextPage) {
    retPages.pop();
  }
  return {
    data: {
      ...data,
      pages: retPages,
    },
    fetchNextPage: preloadNextPage,
    hasNextPage: loadMore,
  };
}
